import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-header-title title-flex" }
const _hoisted_2 = { class: "title-flex" }
const _hoisted_3 = { class: "margin-l-half" }
const _hoisted_4 = { class: "card-header-icon" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }

import {
  mdiCheckboxMarkedCircleOutline,
  mdiCircle,
  mdiCircleOutline,
  mdiMenuDown,
  mdiMenuUp
} from "@mdi/js";
import { computed, PropType } from "vue";

import { TASKS } from "@/constants/assets.constant";

import { TaskStatus } from "@/models/task.model";
import { SidebarTransitionState } from "@/models/transition-state.model";
import { WorkflowState } from "@/models/workflow.model";


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentWorkflowItem',
  props: {
  transition: {
    type: Object as PropType<SidebarTransitionState>,
    required: true
  },
  currentState: {
    type: Object as PropType<WorkflowState>,
    required: true
  },
  submittingStateTransition: {
    type: Boolean,
    required: true
  },
  isPinnedState: {
    type: Boolean,
    required: true
  }
},
  setup(__props) {

const props = __props;

const transitionStatusIsComplete = computed<boolean>(() => {
  return (
    props.transition.status === TaskStatus.COMPLETE ||
    props.transition.status === TaskStatus.FINAL_STATE
  );
});
const transitionStatusIsCurrent = computed<boolean>(() => {
  return (
    props.transition.status === TaskStatus.CURRENT ||
    props.transition.status === TaskStatus.CURRENT_LATE
  );
});
const transitionStatusIsUpcoming = computed<boolean>(() => {
  return (
    props.transition.status === TaskStatus.UPCOMING ||
    props.transition.status === TaskStatus.UPCOMING_LATE
  );
});
const displayedStatus = computed<string>(() => {
  if (transitionStatusIsComplete.value) {
    return TASKS.STATUSES_DISPLAY_NAME.complete;
  }
  if (transitionStatusIsCurrent.value) {
    return TASKS.STATUSES_DISPLAY_NAME.current;
  }
  if (transitionStatusIsUpcoming.value) {
    return TASKS.STATUSES_DISPLAY_NAME.upcoming;
  }
  return TASKS.STATUSES_DISPLAY_NAME.upcoming;
});

const transitionIsOpen = computed<boolean>(() => {
  return props.transition.id === props.currentState.id || props.isPinnedState;
});
const transitionHaveDeadline = computed<boolean>(() => {
  return Boolean(props.transition.deadline);
});
const transitionHaveInstruction = computed<boolean>(() => {
  return Boolean(props.transition.instruction);
});
const transitionHaveAssignedUsers = computed<boolean>(() => {
  return Boolean(props.transition.assignedUsers.length);
});
const transitionIsEmpty = computed<boolean>(() => {
  return (
    !transitionHaveDeadline.value &&
    !transitionHaveInstruction.value &&
    !transitionHaveAssignedUsers.value
  );
});

return (_ctx: any,_cache: any) => {
  const _component_SVGIcon = _resolveComponent("SVGIcon")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item")!
  const _component_b_dropdown = _resolveComponent("b-dropdown")!
  const _component_b_collapse = _resolveComponent("b-collapse")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_b_collapse, {
      class: "card",
      animation: "slide",
      "model-value": transitionIsOpen.value
    }, {
      trigger: _withCtx((props) => [
        _createElementVNode("div", {
          class: _normalizeClass(["card-header", { disable: transitionIsEmpty.value }]),
          role: "button"
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", _hoisted_2, [
              (transitionStatusIsComplete.value)
                ? (_openBlock(), _createBlock(_component_SVGIcon, {
                    key: 0,
                    title: "complete",
                    path: _unref(mdiCheckboxMarkedCircleOutline),
                    type: "is-success",
                    "data-testing": "complete",
                    size: 24
                  }, null, 8, ["path"]))
                : _createCommentVNode("", true),
              (transitionStatusIsCurrent.value)
                ? (_openBlock(), _createBlock(_component_SVGIcon, {
                    key: 1,
                    title: "on track",
                    path: _unref(mdiCircle),
                    type: "is-warning",
                    "data-testing": "on-track",
                    size: 24
                  }, null, 8, ["path"]))
                : _createCommentVNode("", true),
              (transitionStatusIsUpcoming.value)
                ? (_openBlock(), _createBlock(_component_SVGIcon, {
                    key: 2,
                    title: "on track",
                    path: _unref(mdiCircleOutline),
                    type: "is-dark",
                    "data-testing": "on-track",
                    size: 24
                  }, null, 8, ["path"]))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_3, _toDisplayString(__props.transition.name), 1)
            ]),
            _createVNode(_component_b_dropdown, {
              disabled: !__props.transition.isTransitionAvailableForThisUser,
              "aria-role": "list",
              position: "is-bottom-left"
            }, {
              trigger: _withCtx(({ active }) => [
                _createVNode(_component_b_button, {
                  class: _normalizeClass([
                    'btn-transition',
                    {
                      'btn-upcoming': transitionStatusIsUpcoming.value,
                      'btn-in-progress': transitionStatusIsCurrent.value,
                      'btn-complete': transitionStatusIsComplete.value
                    }
                  ]),
                  "icon-right": active ? 'menu-up' : 'menu-down'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(displayedStatus.value), 1)
                  ]),
                  _: 2
                }, 1032, ["class", "icon-right"])
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.transition.availableTransitions, (availableTransition) => {
                  return (_openBlock(), _createBlock(_component_b_dropdown_item, {
                    "aria-role": "listitem",
                    key: availableTransition.id,
                    "data-testing": `state-transition-btn-${availableTransition.id}`,
                    disabled: __props.submittingStateTransition,
                    onClick: ($event: any) => (
                  _ctx.$emit('requestTransitionConfirmation', availableTransition)
                )
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(availableTransition.availableStatus), 1)
                    ]),
                    _: 2
                  }, 1032, ["data-testing", "disabled", "onClick"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _createElementVNode("a", _hoisted_4, [
            _createVNode(_component_SVGIcon, {
              path: props.open ? _unref(mdiMenuDown) : _unref(mdiMenuUp),
              "custom-class": transitionIsEmpty.value ? 'hidden' : '',
              type: "is-dark",
              size: 24
            }, null, 8, ["path", "custom-class"])
          ])
        ], 2)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(['card-content', { hidden: transitionIsEmpty.value }])
        }, [
          _createElementVNode("div", _hoisted_5, [
            (transitionHaveDeadline.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _cache[0] || (_cache[0] = _createElementVNode("strong", null, "Deadline: ", -1)),
                  _createTextVNode(_toDisplayString(__props.transition.deadline), 1)
                ]))
              : _createCommentVNode("", true),
            (transitionHaveInstruction.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _cache[1] || (_cache[1] = _createElementVNode("strong", null, "Instructions: ", -1)),
                  _createTextVNode(_toDisplayString(__props.transition.instruction), 1)
                ]))
              : _createCommentVNode("", true),
            (transitionHaveAssignedUsers.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _cache[2] || (_cache[2] = _createElementVNode("strong", null, "Assigned Users: ", -1)),
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.transition.assignedUsers, (user) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: user.id
                      }, _toDisplayString(user.firstName) + " " + _toDisplayString(user.lastName), 1))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ], 2)
      ]),
      _: 1
    }, 8, ["model-value"])
  ]))
}
}

})